<template>
    <div>
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg12>
                    <v-card>
                        <v-data-table :headers="headers" :items="items" :server-items-length="items.length"
                            :loading="loading" hide-default-footer disable-pagination class="elevation-1">
                            <template v-slot:item="{ item, index }">
                                <tr>
                                    <td class="text-center">{{ index + 1 }}</td>
                                    <td>{{ item.ProductCode }}</td>
                                    <td>{{ item.ProductName }}</td>
                                    <td>{{ item.ProductType }}</td>
                                    <td>{{ item.CustomerName }}</td>
                                    <td>{{ item.SaleName }}</td>
                                    <td class="text-right">{{ formatNumber(item.NumberOfPack, 0) }}</td>
                                    <td class="text-right">{{ formatNumber(item.TotalWeight, 2) }}</td>
                                    <td class="text-right">{{ formatNumber(item.TotalVolume, 3) }}</td>
                                    <td class="text-center">{{ item.StorageDays }}</td>
                                </tr>
                            </template>
                            <template v-slot:body.append>
                                <tr>
                                    <td class="font-weight-bold" colspan="6">TỔNG CỘNG</td>
                                    <td class="font-weight-bold text-right">{{ formatNumber(summary.TotalPack, 0) }}
                                    </td>
                                    <td class="font-weight-bold text-right">{{ formatNumber(summary.TotalWeight, 2) }}
                                    </td>
                                    <td class="font-weight-bold text-right">{{ formatNumber(summary.TotalVolume, 3) }}
                                    </td>
                                    <td></td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
    data() {
        return {
            headers: [
                { text: "STT", value: "index", align: "center", sortable: false },
                { text: "Mã hàng", value: "ProductCode", sortable: true },
                { text: "Tên hàng", value: "ProductName", sortable: true },
                { text: "Loại hàng", value: "ProductType", sortable: true },
                { text: "Khách hàng", value: "CustomerName", sortable: true },
                { text: "Sale", value: "SaleName", sortable: true },
                { text: "Số kiện", value: "NumberOfPack", align: "end", sortable: true },
                { text: "Tổng cân", value: "TotalWeight", align: "end", sortable: true },
                { text: "Tổng khối", value: "TotalVolume", align: "end", sortable: true },
                { text: "Số ngày lưu kho", value: "StorageDays", align: "center", sortable: true },
            ],
        };
    },
    computed: {
        ...mapState({
            reportState: state => state.report.storageByBatchCode,
            loading: state => state.report.loading,
        }),
        items() {
            return _.get(this.reportState, "data", []);
        },
        summary() {
            return {
                TotalPack: _.sumBy(this.items, "NumberOfPack") || 0,
                TotalWeight: _.sumBy(this.items, "TotalWeight") || 0,
                TotalVolume: _.sumBy(this.items, "TotalVolume") || 0,
            };
        },
    },
    methods: {
        formatNumber(value, digits) {
            const num = Number(value || 0);
            return num.toLocaleString("vi-VN", {
                minimumFractionDigits: digits,
                maximumFractionDigits: digits,
            });
        },
        loadData() {
            this.$store.dispatch("report/getStorageByBatchCodeReport", {});
        },
    },
    mounted() {
        this.loadData();
        this.$root.$emit("REQUEST_ROOT_OPTION", {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.loadData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.loadData);
    },
};
</script>

<style scoped>
.summary-table {
    width: 100%;
    border-collapse: collapse;
}

.summary-table td {
    padding: 8px 16px;
    border-top: 1px solid #e0e0e0;
}
</style>
